'use client';

import { c as _c } from "react/compiler-runtime";
import { useRegisterQueryErrorHandler } from '@module/queries';
import { useLoginMustHandler } from '@module/queries/useLoginMustHandler';

/**
 * pandatv-pc의 쿼리 에러 정책 등록부(자기 switch를 소유).
 * 공통 정책(loginMust)은 공용 훅을 조립해 쓰고, 앱-고유 case가 생기면 여기에 추가한다.
 */
export function QueryErrorBridge() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      confirmText: "\uD655\uC778"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleLoginMust = useLoginMustHandler(t0);
  let t1;
  if ($[1] !== handleLoginMust) {
    t1 = (errorCode, error) => {
      switch (errorCode) {
        case "loginMust":
          {
            handleLoginMust(error);
          }
      }
    };
    $[1] = handleLoginMust;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useRegisterQueryErrorHandler(t1);
  return null;
}